export const convertToNumber = (value: string): number => {
  return parseFloat(value?.replace(',', '.'));
};